import React from "react";
import Pages from "./home";
function App() {
  return (
    <>
    <Pages></Pages>
    </>
  );
}

export default App;
